import { render, staticRenderFns } from "./NotAuthenticated.vue?vue&type=template&id=4961a37e&scoped=true"
import script from "./NotAuthenticated.vue?vue&type=script&lang=js"
export * from "./NotAuthenticated.vue?vue&type=script&lang=js"
import style0 from "./NotAuthenticated.vue?vue&type=style&index=0&id=4961a37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4961a37e",
  null
  
)

export default component.exports